export default {
    action: [ 'justifyCenter' ],
    description: 'Center',
    icon: 'Center',
    title: 'justifyCenter',
};
